module.exports = __webpack_public_path__ + "img/network.930728d8.gif";